import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import html2canvas from "html2canvas";

const RolTrabajo = () => {
    const [loading, setLoading] = useState(false);
    const [rolData, setRolData] = useState({
        salinaCruz: [],
        oaxaca: []
    });
    const [todosConductores, setTodosConductores] = useState([]);
    const [todosLetras, setTodosLetras] = useState([]);
    const [fecha, setFecha] = useState(new Date());
    const [editMode, setEditMode] = useState(false);
    const [explicacionSecuencia, setExplicacionSecuencia] = useState("");
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const navigate = useNavigate();

    useEffect(() => {
        obtenerDatosIniciales();
    }, []);

    const obtenerDatosIniciales = async () => {
        setLoading(true);
        try {
            // Obtener todos los conductores
            const conductoresResponse = await axios.get(ENDPOINT + 'get-all-drivers-trips');
            setTodosConductores(conductoresResponse.data.data);
            
            // Obtener todas las letras
            const letrasResponse = await axios.get(ENDPOINT + 'get-all-letters-trips');
            setTodosLetras(letrasResponse.data.data);
            
            // Generar el rol después de obtener los datos
            await generarRolDiaSiguiente(conductoresResponse.data.data, letrasResponse.data.data);
        } catch (error) {
            console.error("Error al obtener datos iniciales:", error);
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar los datos iniciales'
            });
        }
    };

    // Función para debuguear y ver la estructura real de los datos
    const debugViajes = (viajes, titulo) => {
        console.log(`=== ${titulo} ===`);
        console.log("Cantidad de viajes:", viajes.length);
        if (viajes.length > 0) {
            console.log("Primer viaje:", viajes[0]);
            console.log("Estructura del driver:", viajes[0].driver);
            console.log("Estructura del schedule:", viajes[0].schedule);
        }
    };

    const generarRolDiaSiguiente = async (todosConductores, todasLetras) => {
        try {
            // Obtener los viajes del día de hoy
            const hoy = new Date().toISOString().split('T')[0];
            console.log("Buscando viajes para la fecha:", hoy);
            
            // Intentar con diferentes formatos de request
            let viajesHoy = [];
            
            try {
                // Primero intentar con FormData
                const formData = new FormData();
                formData.append('date', hoy);
                formData.append('status_filter', 1);
                formData.append('unit_filter', 0);
                
                const viajesResponse = await axios.post(ENDPOINT + 'get-trips-day', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                
                viajesHoy = viajesResponse.data.data || [];
                debugViajes(viajesHoy, "Viajes obtenidos con FormData");
                
            } catch (error1) {
                console.log("Error con FormData, intentando con JSON:", error1);
                
                try {
                    // Intentar con JSON
                    const viajesResponse = await axios.post(ENDPOINT + 'get-trips-day', {
                        date: hoy,
                        status_filter: 1,
                        unit_filter: 0
                    });
                    
                    viajesHoy = viajesResponse.data.data || [];
                    debugViajes(viajesHoy, "Viajes obtenidos con JSON");
                    
                } catch (error2) {
                    console.log("Error con JSON, intentando endpoint alternativo:", error2);
                    
                    try {
                        // Intentar con searchTripsDay
                        const viajesResponse = await axios.post(ENDPOINT + 'searchTripsDay', {
                            date: hoy,
                            status_filter: 1,
                            unit_filter: 0
                        });
                        
                        viajesHoy = viajesResponse.data.data || [];
                        debugViajes(viajesHoy, "Viajes obtenidos con searchTripsDay");
                        
                    } catch (error3) {
                        console.log("Todos los métodos fallaron:", error3);
                        throw new Error("No se pudieron obtener los viajes del día");
                    }
                }
            }
            
            console.log("Viajes de hoy:", viajesHoy.length);
            
            // Obtener conductores únicos que trabajaron hoy, ordenados por horario
            const conductoresHoy = [];
            const conductoresUnicos = new Set();
            
            // Verificar la estructura de los datos y extraer conductores
            viajesHoy.forEach(viaje => {
                // Diferentes posibles estructuras de datos
                let driver = null;
                
                if (viaje.driver && viaje.driver.driver_id) {
                    driver = viaje.driver;
                } else if (viaje.driver_id && viaje.driver_name) {
                    // Estructura alternativa
                    driver = {
                        driver_id: viaje.driver_id,
                        name: viaje.driver_name,
                        last_name: viaje.driver_last_name || ''
                    };
                }
                
                if (driver && driver.driver_id && !conductoresUnicos.has(driver.driver_id)) {
                    conductoresUnicos.add(driver.driver_id);
                    conductoresHoy.push(driver);
                }
            });
            
            console.log("Conductores que trabajaron hoy:", conductoresHoy.map(c => `${c.name} ${c.last_name}`));
            
            // Si no hay conductores, intentar obtenerlos de otra manera
            if (conductoresHoy.length === 0) {
                console.log("No se encontraron conductores en viajes, intentando método alternativo...");
                
                try {
                    // Buscar conductores que tengan viajes hoy
                    const conductoresResponse = await axios.post(ENDPOINT + 'get-drivers-with-trips', {
                        date: hoy
                    });
                    
                    if (conductoresResponse.data.data && conductoresResponse.data.data.length > 0) {
                        conductoresResponse.data.data.forEach(conductor => {
                            if (!conductoresUnicos.has(conductor.driver_id)) {
                                conductoresUnicos.add(conductor.driver_id);
                                conductoresHoy.push(conductor);
                            }
                        });
                    }
                } catch (error) {
                    console.log("No se pudieron obtener conductores alternativamente:", error);
                }
            }
            
            // Obtener los últimos viajes por sucursal
            let ultimosViajes = [];
            try {
                const ultimosViajesResponse = await axios.post(ENDPOINT + 'get-last-trips-by-branch', {
                    date: hoy
                });
                ultimosViajes = ultimosViajesResponse.data.data || [];
                console.log("Últimos viajes por sucursal:", ultimosViajes);
            } catch (error) {
                console.log("Error al obtener últimos viajes:", error);
                // Crear estructura vacía para continuar
                ultimosViajes = [
                    { branch: { branch_id: 1, name: 'OAXACA' }, last_trip: null },
                    { branch: { branch_id: 2, name: 'SALINA CRUZ' }, last_trip: null }
                ];
            }
            
            // Obtener el último conductor de cada sucursal
            let ultimoSalinaCruz = null;
            let ultimoOaxaca = null;
            
            ultimosViajes.forEach(viaje => {
                if (viaje.branch && viaje.branch.branch_id === 2 && viaje.last_trip) {
                    if (viaje.last_trip.driver && viaje.last_trip.driver.driver_id) {
                        ultimoSalinaCruz = viaje.last_trip.driver;
                    } else if (viaje.last_trip.driver_id) {
                        // Estructura alternativa
                        ultimoSalinaCruz = {
                            driver_id: viaje.last_trip.driver_id,
                            name: viaje.last_trip.driver_name || 'Desconocido',
                            last_name: viaje.last_trip.driver_last_name || ''
                        };
                    }
                } else if (viaje.branch && viaje.branch.branch_id === 1 && viaje.last_trip) {
                    if (viaje.last_trip.driver && viaje.last_trip.driver.driver_id) {
                        ultimoOaxaca = viaje.last_trip.driver;
                    } else if (viaje.last_trip.driver_id) {
                        // Estructura alternativa
                        ultimoOaxaca = {
                            driver_id: viaje.last_trip.driver_id,
                            name: viaje.last_trip.driver_name || 'Desconocido',
                            last_name: viaje.last_trip.driver_last_name || ''
                        };
                    }
                }
            });
            
            console.log("Último conductor Salina Cruz:", ultimoSalinaCruz);
            console.log("Último conductor Oaxaca:", ultimoOaxaca);
            
            let secuenciaSalinaCruz = [];
            let secuenciaOaxaca = [];
            let explicacion = "EXPLICACIÓN DE LA SECUENCIA:\n\n";
            
            // Si no hay conductores que trabajaron hoy, usar todos los conductores activos
            if (conductoresHoy.length === 0) {
                const conductoresActivos = todosConductores.filter(c => c.status === 1);
                secuenciaSalinaCruz = conductoresActivos;
                secuenciaOaxaca = conductoresActivos;
                
                explicacion += "No se encontraron viajes para hoy\n";
                explicacion += "Se usaron todos los conductores activos para ambas sucursales\n\n";
                
                console.log("Usando todos los conductores activos:", conductoresActivos.length);
            } else {
                explicacion += `Se encontraron ${conductoresHoy.length} conductores que trabajaron hoy\n\n`;
                
                // Generar secuencia para Salina Cruz (continúa desde donde terminó Oaxaca)
                if (ultimoOaxaca) {
                    const indexOaxaca = conductoresHoy.findIndex(c => c.driver_id === ultimoOaxaca.driver_id);
                    if (indexOaxaca !== -1) {
                        // Comenzar desde el siguiente conductor después del último de Oaxaca
                        secuenciaSalinaCruz = [
                            ...conductoresHoy.slice(indexOaxaca + 1),
                            ...conductoresHoy.slice(0, indexOaxaca + 1)
                        ];
                        explicacion += `SALINA CRUZ:\n`;
                        explicacion += `- Oaxaca terminó con: ${ultimoOaxaca.name} ${ultimoOaxaca.last_name}\n`;
                        explicacion += `- Salina Cruz continúa con: ${secuenciaSalinaCruz[0]?.name || 'N/A'} ${secuenciaSalinaCruz[0]?.last_name || ''}\n\n`;
                    } else {
                        // Si el último conductor de Oaxaca no trabajó hoy, comenzar desde el principio
                        secuenciaSalinaCruz = conductoresHoy;
                        explicacion += `SALINA CRUZ:\n`;
                        explicacion += `- Oaxaca terminó con: ${ultimoOaxaca.name} ${ultimoOaxaca.last_name} (no trabajó hoy)\n`;
                        explicacion += `- Salina Cruz inicia secuencia desde el principio\n\n`;
                    }
                } else {
                    // Si Oaxaca no tuvo viajes hoy, comenzar desde el principio
                    secuenciaSalinaCruz = conductoresHoy;
                    explicacion += `SALINA CRUZ:\n`;
                    explicacion += `- Oaxaca no tuvo viajes hoy\n`;
                    explicacion += `- Salina Cruz inicia secuencia desde el principio\n\n`;
                }
                
                // Generar secuencia para Oaxaca (continúa desde donde terminó Salina Cruz)
                if (ultimoSalinaCruz) {
                    const indexSalina = conductoresHoy.findIndex(c => c.driver_id === ultimoSalinaCruz.driver_id);
                    if (indexSalina !== -1) {
                        // Comenzar desde el siguiente conductor después del último de Salina Cruz
                        secuenciaOaxaca = [
                            ...conductoresHoy.slice(indexSalina + 1),
                            ...conductoresHoy.slice(0, indexSalina + 1)
                        ];
                        explicacion += `OAXACA:\n`;
                        explicacion += `- Salina Cruz terminó con: ${ultimoSalinaCruz.name} ${ultimoSalinaCruz.last_name}\n`;
                        explicacion += `- Oaxaca continúa con: ${secuenciaOaxaca[0]?.name || 'N/A'} ${secuenciaOaxaca[0]?.last_name || ''}\n\n`;
                    } else {
                        // Si el último conductor de Salina Cruz no trabajó hoy, comenzar desde el principio
                        secuenciaOaxaca = conductoresHoy;
                        explicacion += `OAXACA:\n`;
                        explicacion += `- Salina Cruz terminó con: ${ultimoSalinaCruz.name} ${ultimoSalinaCruz.last_name} (no trabajó hoy)\n`;
                        explicacion += `- Oaxaca inicia secuencia desde el principio\n\n`;
                    }
                } else {
                    // Si Salina Cruz no tuvo viajes hoy, comenzar desde el principio
                    secuenciaOaxaca = conductoresHoy;
                    explicacion += `OAXACA:\n`;
                    explicacion += `- Salina Cruz no tuvo viajes hoy\n`;
                    explicacion += `- Oaxaca inicia secuencia desde el principio\n\n`;
                }
            }
            
            // Agregar detalles de las secuencias
            explicacion += `CONDUCTORES QUE TRABAJARON HOY (${conductoresHoy.length}):\n`;
            conductoresHoy.forEach((conductor, index) => {
                explicacion += `${index + 1}. ${conductor.name} ${conductor.last_name}\n`;
            });
            
            explicacion += `\nSECUENCIA SALINA CRUZ:\n`;
            secuenciaSalinaCruz.forEach((conductor, index) => {
                explicacion += `${index + 1}. ${conductor.name} ${conductor.last_name}\n`;
            });
            
            explicacion += `\nSECUENCIA OAXACA:\n`;
            secuenciaOaxaca.forEach((conductor, index) => {
                explicacion += `${index + 1}. ${conductor.name} ${conductor.last_name}\n`;
            });
            
            setExplicacionSecuencia(explicacion);
            console.log("Secuencia Salina Cruz:", secuenciaSalinaCruz.map(c => `${c.name} ${c.last_name}`));
            console.log("Secuencia Oaxaca:", secuenciaOaxaca.map(c => `${c.name} ${c.last_name}`));
            
            // Obtener horarios para el día siguiente
            const manana = new Date();
            manana.setDate(manana.getDate() + 1);
            const fechaManana = manana.toISOString().split('T')[0];
            
            let horarios = [];
            try {
                const horariosResponse = await axios.post(ENDPOINT + 'search-schedule-day', {
                    date: fechaManana
                });
                horarios = horariosResponse.data.data || [];
            } catch (error) {
                console.log("Error al obtener horarios:", error);
                // Crear horarios de ejemplo para continuar
                horarios = [
                    { time: "06:00", branch_id: 1, letter_id: 1, state: 1, status: 1 },
                    { time: "08:00", branch_id: 1, letter_id: 2, state: 1, status: 1 },
                    { time: "10:00", branch_id: 1, letter_id: 3, state: 1, status: 1 },
                    { time: "12:00", branch_id: 1, letter_id: 4, state: 1, status: 1 },
                    { time: "14:00", branch_id: 1, letter_id: 5, state: 1, status: 1 },
                    { time: "16:00", branch_id: 1, letter_id: 6, state: 1, status: 1 },
                    { time: "06:00", branch_id: 2, letter_id: 1, state: 1, status: 1 },
                    { time: "08:00", branch_id: 2, letter_id: 2, state: 1, status: 1 },
                    { time: "10:00", branch_id: 2, letter_id: 3, state: 1, status: 1 },
                    { time: "12:00", branch_id: 2, letter_id: 4, state: 1, status: 1 },
                    { time: "14:00", branch_id: 2, letter_id: 5, state: 1, status: 1 },
                    { time: "16:00", branch_id: 2, letter_id: 6, state: 1, status: 1 }
                ];
            }
            
            // Filtrar solo horarios activos (state = 1, status = 1)
            const horariosActivos = horarios.filter(horario => 
                horario.state === 1 && horario.status === 1
            );
            
            // Filtrar horarios por branch_id correcto
            const horariosSalinaCruz = horariosActivos.filter(horario => 
                horario.branch_id === 2 // Salina Cruz
            );
            
            const horariosOaxaca = horariosActivos.filter(horario => 
                horario.branch_id === 1 // Oaxaca
            );
            
            // Eliminar duplicados por tiempo
            const horariosUnicosSalina = eliminarDuplicadosPorTiempo(horariosSalinaCruz);
            const horariosUnicosOaxaca = eliminarDuplicadosPorTiempo(horariosOaxaca);
            
            // Ordenar horarios por tiempo
            horariosUnicosSalina.sort((a, b) => a.time.localeCompare(b.time));
            horariosUnicosOaxaca.sort((a, b) => a.time.localeCompare(b.time));
            
            // Combinar horarios con conductores
            const rolSalinaCruz = combinarHorariosConConductores(horariosUnicosSalina, secuenciaSalinaCruz, todasLetras);
            const rolOaxaca = combinarHorariosConConductores(horariosUnicosOaxaca, secuenciaOaxaca, todasLetras);
            
            setRolData({
                salinaCruz: rolSalinaCruz,
                oaxaca: rolOaxaca
            });
            
            setFecha(manana);
            setLoading(false);
        } catch (error) {
            console.error("Error al generar rol:", error);
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo generar el rol del día siguiente: ' + error.message
            });
        }
    };

    const eliminarDuplicadosPorTiempo = (horarios) => {
        const horariosUnicos = [];
        const tiemposVistos = new Set();
        
        horarios.forEach(horario => {
            if (!tiemposVistos.has(horario.time)) {
                tiemposVistos.add(horario.time);
                horariosUnicos.push({
                    ...horario,
                    time: formatearHoraParaOrdenar(horario.time)
                });
            }
        });
        
        return horariosUnicos;
    };

    const formatearHoraParaOrdenar = (hora) => {
        if (!hora) return "00:00";
        const [horas, minutos] = hora.split(':');
        return `${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
    };

    const combinarHorariosConConductores = (horarios, conductores, letras) => {
        if (!horarios || !conductores || conductores.length === 0) return [];
        
        return horarios.map((horario, index) => {
            const conductorIndex = index % conductores.length;
            // Encontrar la letra correspondiente al horario
            const letraHorario = letras.find(l => l.letter_id === horario.letter_id);
            
            return {
                horario: horario.time,
                conductor: conductores[conductorIndex],
                letra: letraHorario ? letraHorario.name : "Sin asignar",
                letra_id: horario.letter_id || null
            };
        });
    };

    const handleEdit = (sucursal, index, campo, valor) => {
        const newData = {...rolData};
        
        if (campo === 'conductor') {
            newData[sucursal][index].conductor = valor;
        } else if (campo === 'letra') {
            newData[sucursal][index].letra = valor.name || valor;
            newData[sucursal][index].letra_id = valor.letter_id || valor;
        }
        
        setRolData(newData);
    };

    const exportarImagen = () => {
        const element = document.getElementById('rol-trabajo');
        html2canvas(element).then(canvas => {
            const enlace = document.createElement('a');
            enlace.download = `rol_trabajo_${fecha.toISOString().split('T')[0]}.png`;
            enlace.href = canvas.toDataURL('image/png');
            enlace.click();
        });
    };

    const formatearHora = (hora) => {
        if (!hora) return "";
        const [horas, minutos] = hora.split(':');
        return `${horas}:${minutos}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader
                    title="Rol de Trabajo - Día Siguiente"
                />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-md-6">
                                <h4 className="card-title m-0">
                                    <i className="bi bi-calendar-check me-2"></i> 
                                    Rol para {fecha.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                </h4>
                            </div>
                            <div className="col-md-6 text-end">
                                <button 
                                    className="btn btn-info btn-sm me-2"
                                    onClick={() => setEditMode(!editMode)}
                                >
                                    <i className={`fa ${editMode ? 'fa-check' : 'fa-edit'} me-1`}></i>
                                    {editMode ? 'Finalizar Edición' : 'Editar Rol'}
                                </button>
                                <button 
                                    className="btn btn-success btn-sm me-2"
                                    onClick={exportarImagen}
                                >
                                    <i className="fa fa-download me-1"></i> Exportar Imagen
                                </button>
                                <button 
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => navigate('/trips')}
                                >
                                    <i className="fa fa-arrow-left me-1"></i> Volver
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div id="rol-trabajo" style={{ backgroundColor: 'white', padding: '20px' }}>
                            <div className="row mb-4">
                                <div className="col-md-12 text-center">
                                    <h2 style={{ fontWeight: 'bold', marginBottom: '5px' }}>ROL DE TRABAJO</h2>
                                    <h3 style={{ marginTop: '0' }}>{fecha.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</h3>
                                </div>
                            </div>
                            
                            <div className="row">
                                {/* Columna Salina Cruz */}
                                <div className="col-md-6">
                                    <div style={{ 
                                        backgroundColor: '#ff8c00', 
                                        color: 'white', 
                                        padding: '10px', 
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        marginBottom: '15px'
                                    }}>
                                        SALINA CRUZ (branch_id: 2)
                                    </div>
                                    
                                    <table className="table table-bordered" style={{ marginBottom: '0' }}>
                                        <thead>
                                            <tr>
                                                <th width="20%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>HORARIO</th>
                                                <th width="15%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>LETRA</th>
                                                <th width="65%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>CONDUCTOR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rolData.salinaCruz.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                        {formatearHora(item.horario)}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {editMode ? (
                                                            <select 
                                                                className="form-control form-control-sm"
                                                                value={item.letra_id || ''}
                                                                onChange={(e) => {
                                                                    const selectedLetra = todosLetras.find(l => l.letter_id === parseInt(e.target.value));
                                                                    handleEdit('salinaCruz', index, 'letra', selectedLetra);
                                                                }}
                                                            >
                                                                <option value="">Seleccionar letra</option>
                                                                {todosLetras.map(letra => (
                                                                    <option key={letra.letter_id} value={letra.letter_id}>
                                                                        {letra.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            item.letra
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editMode ? (
                                                            <select 
                                                                className="form-control form-control-sm"
                                                                value={item.conductor?.driver_id || ''}
                                                                onChange={(e) => {
                                                                    const selectedDriver = todosConductores.find(c => c.driver_id === parseInt(e.target.value));
                                                                    handleEdit('salinaCruz', index, 'conductor', selectedDriver);
                                                                }}
                                                            >
                                                                <option value="">Seleccionar conductor</option>
                                                                {todosConductores.map(conductor => (
                                                                    <option key={conductor.driver_id} value={conductor.driver_id}>
                                                                        {conductor.name} {conductor.last_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            item.conductor ? `${item.conductor.name} ${item.conductor.last_name}` : 'Sin asignar'
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {/* Columna Oaxaca */}
                                <div className="col-md-6">
                                    <div style={{ 
                                        backgroundColor: '#1e90ff', 
                                        color: 'white', 
                                        padding: '10px', 
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        marginBottom: '15px'
                                    }}>
                                        OAXACA (branch_id: 1)
                                    </div>
                                    
                                    <table className="table table-bordered" style={{ marginBottom: '0' }}>
                                        <thead>
                                            <tr>
                                                <th width="20%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>HORA</th>
                                                <th width="15%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>LETRA</th>
                                                <th width="65%" style={{ textAlign: 'center', backgroundColor: '#f8f9fa' }}>CONDUCTOR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rolData.oaxaca.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                        {formatearHora(item.horario)}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {editMode ? (
                                                            <select 
                                                                className="form-control form-control-sm"
                                                                value={item.letra_id || ''}
                                                                onChange={(e) => {
                                                                    const selectedLetra = todosLetras.find(l => l.letter_id === parseInt(e.target.value));
                                                                    handleEdit('oaxaca', index, 'letra', selectedLetra);
                                                                }}
                                                            >
                                                                <option value="">Seleccionar letra</option>
                                                                {todosLetras.map(letra => (
                                                                    <option key={letra.letter_id} value={letra.letter_id}>
                                                                        {letra.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            item.letra
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editMode ? (
                                                            <select 
                                                                className="form-control form-control-sm"
                                                                value={item.conductor?.driver_id || ''}
                                                                onChange={(e) => {
                                                                    const selectedDriver = todosConductores.find(c => c.driver_id === parseInt(e.target.value));
                                                                    handleEdit('oaxaca', index, 'conductor', selectedDriver);
                                                                }}
                                                            >
                                                                <option value="">Seleccionar conductor</option>
                                                                {todosConductores.map(conductor => (
                                                                    <option key={conductor.driver_id} value={conductor.driver_id}>
                                                                        {conductor.name} {conductor.last_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            item.conductor ? `${item.conductor.name} ${item.conductor.last_name}` : 'Sin asignar'
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Sección de Anotaciones */}
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header bg-light">
                                            <h5 className="card-title m-0">
                                                <i className="bi bi-info-circle me-2"></i>
                                                Anotaciones - Explicación de la Secuencia
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
                                                {explicacionSecuencia}
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RolTrabajo;